module.exports = __webpack_public_path__ + "img/remove.fdab9c8e.svg";